import { render, staticRenderFns } from "./transactionReport.vue?vue&type=template&id=10008af0&scoped=true"
import script from "./transactionReport.vue?vue&type=script&lang=ts"
export * from "./transactionReport.vue?vue&type=script&lang=ts"
import style0 from "./transactionReport.vue?vue&type=style&index=0&id=10008af0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10008af0",
  null
  
)

export default component.exports